import { RequestBase } from "@myapp/modules/fwcore/models/messages/request-base";
import { ResponseBase } from "@myapp/modules/fwcore/models/messages/response-base";

export class RequestLicenseUserSet extends RequestBase {
  licenseId?: string | null;
  data?: string[] | null;
  assign?: boolean | null;

}

export class ResponseLicenseUserSet extends ResponseBase {
  data?: string[] | null;
  assign?: boolean | null;
}
